import { Component, OnInit } from '@angular/core';
import { ConexionesService } from '../../services/conexiones.service'

import { environment } from "../../../environments/environment";



@Component({
  selector: 'app-becas',
  templateUrl: './becas.component.html',
  styleUrls: ['./becas.component.css']
})
export class BecasComponent implements OnInit {
  folio: any;
  estado: any
  bandera = false;
  tipo: any;
  nombre: any;
  apaterno: any;
  amaterno: any;
  porFolio = false;
  folio2: any;
  norobot = false;
  siteKey = environment.KEY_CAPTCHA;
  lang = "es";
  captcha = false;
  escuela: any;
  motivo = "";
  total = 0
  constructor(private db: ConexionesService) {


  }

  ngOnInit(): void {
    this.folio = "";
    this.nombre = "";
    this.apaterno = "";
    this.amaterno = "";
    this.tipo = "1";
    this.opcionSelect()
    this.db.getVisitantes().then((resp) => {
      console.log(resp[0].total)
      this.total = resp[0].total
    })

  }


  opcionSelect() {
    this.bandera = false;
    this.folio = "";
    this.nombre = "";
    this.apaterno = "";
    this.amaterno = "";
    this.escuela = "";

    if (this.tipo == "1") {
      this.porFolio = true;
    }
    if (this.tipo == "2") {
      this.porFolio = false;
    }
  }
  onKeydownEvent() {

    this.bandera = false;
  }

  enviarFolio() {
    this.motivo = '';
    this.estado = "";
    this.bandera = true;

    if (this.tipo == "2") {
      this.folio = "";
    }

    let contiene = this.folio.toUpperCase().includes("BTD")
    let contiene2 = this.folio.toUpperCase().includes("BDAC")
    let contiene3 = this.folio.toUpperCase().includes("EU")
    let contiene4 = this.folio.toUpperCase().includes("TP")
    let contiene5 = this.folio.toUpperCase().includes("EE")


    if (contiene == true) {
      console.log("entra")
      this.db.getFolioBecaBTD(this.folio).then((data: any) => {
        this.bandera = true;

        console.log(data)
        if (data[0].idestado == 3) {
          this.estado = "AUTORIZADO";
          this.motivo = '';
          this.folio2 = data[0].folio;
        } else {
          this.estado = "NO AUTORIZADO";

          if (data.length > 1) {
            console.log("entra acss" + data[1].justificacion)
            //  this.motivo = data[1].justificacion;
            this.motivo = ''
            console.log(this.motivo)
            if (this.motivo == '') {
              if (data.length >= 3) {
                //this.motivo = data[2].justificacion;

                if (this.motivo == "") {
                  //  this.motivo = data[0].justificacion;
                  this.folio2 = data[0].folio;
                }
              }
            }
            this.motivo = ''
          } else {

            // this.motivo = data[0].justificacion;
            this.folio2 = data[0].folio;
          }
        }

        this.motivo = ''

      })
    }
    if (contiene2 == true) {

      this.db.getFolioBecaBDAC(this.folio).then((data: any) => {
        this.bandera = true;

        console.log(data[0])
        if (data[0].idestado == 3) {
          this.estado = "AUTORIZADO";
          this.motivo = '';
          this.folio2 = data[0].folio;
        } else {
          this.estado = "NO AUTORIZADO";

          if (data.length >= 1) {

            this.motivo = ''



            if (data.length >= 3) {
              this.motivo = data[0].justificacion;

              if (this.motivo == "") {
                this.motivo = data[0].justificacion;
                this.folio2 = data[0].folio;
              }
            } else {

              this.motivo = data[0].justificacion;
            }


          } else {

            this.motivo = data[0].justificacion;
            this.folio2 = data[0].folio;
          }
        }



      })
    }
    if (contiene3 == true) {

      this.db.getFolioBecaUniversitaria(this.folio).then((data: any) => {
        this.bandera = true;

        console.log(data[0])
        if (data[0].idestado == 3) {
          this.estado = "AUTORIZADO";
          this.motivo = '';
          this.folio2 = data[0].folio;
        } else {
          this.estado = "NO AUTORIZADO";

          if (data.length >= 1) {

            this.motivo = ''



            if (data.length >= 3) {
              this.motivo = data[0].justificacion;

              if (this.motivo == "") {
                this.motivo = data[0].justificacion;
                this.folio2 = data[0].folio;
              }
            } else {

              this.motivo = data[0].justificacion;
            }


          } else {

            this.motivo = data[0].justificacion;
            this.folio2 = data[0].folio;
          }
        }


        if (data[0].idestado == 5) {
          this.db.getFolioBecaUniversitaria2(this.folio).then((data: any) => {
            this.estado = "NO AUTORIZADO";

            if (data.length >= 1) {

              this.motivo = ''



              if (data.length >= 3) {
                this.motivo = data[0].justificacion;

                if (this.motivo == "") {
                  this.motivo = data[0].justificacion;
                  this.folio2 = data[0].folio;
                }
              } else {

                this.motivo = data[0].justificacion;
              }


            } else {

              this.motivo = data[0].justificacion;
              this.folio2 = data[0].folio;
            }
          })
        }


      })
    }
    if (contiene4 == true) {

      this.db.getFolioTitulacionProf(this.folio).then((data: any) => {
        this.bandera = true;

        console.log(data[0])
        if (data[0].idestado == 3) {
          this.estado = "AUTORIZADO";
          this.motivo = '';
          this.folio2 = data[0].folio;
        } else {
          this.estado = "NO AUTORIZADO";

          if (data.length >= 1) {

            this.motivo = ''



            if (data.length >= 3) {
              this.motivo = data[0].justificacion;

              if (this.motivo == "") {
                this.motivo = data[0].justificacion;
                this.folio2 = data[0].folio;
              }
            } else {

              this.motivo = data[0].justificacion;
            }


          } else {

            this.motivo = data[0].justificacion;
            this.folio2 = data[0].folio;
          }
        }

        /*
        if (data[0].idestado == 5) {
          this.db.getFolioBecaUniversitaria2(this.folio).then((data: any) => {
            this.estado = "NO AUTORIZADO";

            if (data.length >= 1) {

              this.motivo = ''



              if (data.length >= 3) {
                this.motivo = data[0].justificacion;

                if (this.motivo == "") {
                  this.motivo = data[0].justificacion;
                  this.folio2 = data[0].folio;
                }
              } else {

                this.motivo = data[0].justificacion;
              }


            } else {

              this.motivo = data[0].justificacion;
              this.folio2 = data[0].folio;
            }
          })
        }
        */

      })
    }
    if (contiene5 == true) {

      this.db.getFolioEE(this.folio).then((data: any) => {
        this.bandera = true;

        console.log(data[0])
        if (data[0].idestado == 3) {
          this.estado = "AUTORIZADO";
          this.motivo = '';
          this.folio2 = data[0].folio;
        } else {
          this.estado = "NO AUTORIZADO";

          if (data.length == 1) {
            this.motivo = data[0].justificacion;
            this.folio2 = data[0].folio;
          }
          if (data.length == 2) {
            this.motivo = data[1].justificacion;
            this.folio2 = data[1].folio;
          }
          if (data.length == 3) {
            this.motivo = data[2].justificacion;
            this.folio2 = data[2].folio;
          }
        }


      })
    }

    /* else {
      this.db.getFolioBeca2024(this.folio).then((data: any) => {
        this.bandera = true;

        console.log(data)
        if (data[0].idestado == 3) {
          this.estado = "AUTORIZADO";
          this.motivo = '';
          this.folio2 = data[0].folio;
        } else {
          this.estado = "NO AUTORIZADO";
          console.log(data.length)
          if (data.length == 1) {
            this.motivo = data[0].justificacion;
          }
          if (data.length == 2) {
            this.motivo = data[1].justificacion;
          }
          if (data.length == 3) {
            this.motivo = data[2].justificacion;
          }
          if (data.length == 4) {
            this.motivo = data[3].justificacion;
          }


        }



      })

    }*/




  }
  handleSuccess(e) {
    this.captcha = true;
    this.norobot = true;

  }

  handleExpire(e) {
    this.captcha = false;
  }

}
